import { render } from "./JoinPublicationPassword.vue.js?vue&type=template&id=4051ab1d!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPassword.vue?vue&type=template&id=4051ab1d"
import script from "./JoinPublicationPassword.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPassword.vue?vue&type=script&lang=js"
export * from "./JoinPublicationPassword.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4051ab1d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4051ab1d', __exports__)) {
    api.reload('4051ab1d', __exports__)
  }
  
  module.hot.accept("./JoinPublicationPassword.vue.js?vue&type=template&id=4051ab1d!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPassword.vue?vue&type=template&id=4051ab1d", () => {
    api.rerender('4051ab1d', render)
  })

}


export default __exports__